// extracted by mini-css-extract-plugin
export var deck = "hero-module--deck--Vlv+j";
export var root = "hero-module--root--zl+2B";